'use client';
import React from 'react';

import {
  Box,
  Button,
  Container,
  HStack,
  Image,
  Link,
  SectionHeading,
  Text,
} from '@/components';
import { useCategories, useTranslation } from '@/hooks';
import { routes } from '@/statics';

const Categories: React.FC = () => {
  const { data: categoriesData } = useCategories();
  const rootCategories = categoriesData?.filter(
    (item) => item.parent_code === null
  );

  const [showMore, setShowMore] = React.useState(false);
  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };

  const { t } = useTranslation('pages.home');

  return (
    <Container>
      <Box
        gap="30px"
        py="50px"
        px={{ base: 0, md: 10 }}
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <SectionHeading
          title={t('LiaProductCategories')}
          subtitle={t('chooseCategory')}
          textAlign="center"
        />
        <HStack
          mt={5}
          mb={2.5}
          px={{ base: 2.5, md: 0 }}
          columnGap={{ base: 1, md: 5 }}
          rowGap={4}
          maxW="1100px"
          w="full"
          flexWrap="wrap"
          justify={{ base: 'space-between', md: 'center' }}
        >
          {rootCategories
            ?.slice(0, showMore ? rootCategories.length : 8)
            .map((category) => (
              <Link
                flex={{ base: 1, md: 0 }}
                minW="116px"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                href={routes.category.href(category.code)}
                key={category.id}
              >
                <Box
                  bg="secondary.50"
                  borderRadius="50%"
                  outline="5px solid"
                  outlineColor="rgba(243, 169, 181, 0.55)"
                  h="96px"
                  w="96px"
                  display="flex"
                  position="relative"
                  sx={{
                    img: {
                      objectFit: 'cover',
                      padding: '10px',
                    },
                  }}
                >
                  <Box
                    boxShadow="0px 0px 4px 2px rgba(243, 169, 181, 0.22)"
                    h="106px"
                    w="106px"
                    top={'-5px'}
                    left={'-5px'}
                    position="absolute"
                    borderRadius="50%"
                  />
                  <Image
                    src={category.image || ''}
                    alt={category.id}
                    fill
                    sizes="50vw"
                  />
                </Box>
                <Box h="48px">
                  <Text
                    fontSize="md"
                    textAlign="center"
                    fontWeight="bold"
                    marginTop={3}
                    lineHeight="23px"
                  >
                    {category.title}
                  </Text>
                </Box>
              </Link>
            ))}
        </HStack>
        {!showMore && rootCategories && rootCategories?.length > 8 && (
          <Button variant="outline" onClick={handleShowMore}>
            {t('showMore')}
          </Button>
        )}
        {showMore && (
          <Button variant="outline" onClick={handleShowMore}>
            {t('showLess')}
          </Button>
        )}
      </Box>
    </Container>
  );
};
export default Categories;
